(ns practitest.frontend.users-view.subs
  (:require [clojure.string :as str]
            [practitest.frontend.common.i18n :refer [get-translation format-translation]]
            [practitest.frontend.common.utils :as common-utils]
            [practitest.frontend.components.grid.subs :as grid-subs]
            [practitest.frontend.users-view.utils :as utils]
            [re-frame.core :as re-frame]))

(re-frame/reg-sub ::state (fn [db _] (:users-view db)))
(re-frame/reg-sub ::loading? :<- [::state] (fn [s _] (boolean (:loading? s))))
(re-frame/reg-sub ::users :<- [::state] (fn [s _] (:users s)))
(re-frame/reg-sub ::seat-type-options :<- [::state] (fn [s _] (:seat-type-options s)))
(re-frame/reg-sub ::all-groups :<- [::state] (fn [s _] (:all-groups s)))
(re-frame/reg-sub ::active-modal :<- [::state] (fn [s _] (:active-modal s)))
(re-frame/reg-sub ::modal-row :<- [::state] (fn [s _] (:modal-row s)))
(re-frame/reg-sub ::rename-value :<- [::state] (fn [s _] (:rename-value s)))
(re-frame/reg-sub ::pat-value :<- [::state] (fn [s _] (:pat-value s)))
(re-frame/reg-sub ::current-user-id :<- [::state] (fn [s _] (:current-user-id s)))
(re-frame/reg-sub ::full-data? :<- [::state] (fn [s _] (boolean (:full-data? s))))
(re-frame/reg-sub ::seats-usage :<- [::state] (fn [s _] (get s :seats-usage [])))
(re-frame/reg-sub ::pat-for-new-users-supported? :<- [::state] (fn [s _] (boolean (:pat-for-new-users-supported? s))))
(re-frame/reg-sub ::pat-for-new-users? :<- [::state] (fn [s _] (boolean (:pat-for-new-users? s))))
(re-frame/reg-sub ::notify-license-change-supported? :<- [::state] (fn [s _] (boolean (:notify-license-change-supported? s))))
(re-frame/reg-sub ::notify-license-change? :<- [::state] (fn [s _] (boolean (:notify-license-change? s))))
(re-frame/reg-sub ::concurrent-licensing? :<- [::state] (fn [s _] (boolean (:concurrent-licensing? s))))
(re-frame/reg-sub ::multiple-owners-supported? :<- [::state] (fn [s _] (get s :multiple-owners-supported? true)))
(re-frame/reg-sub ::show-last-active-time? :<- [::state] (fn [s _] (boolean (:show-last-active-time? s))))
(re-frame/reg-sub ::active-tab :<- [::state] (fn [s _] (get s :active-tab :users-view)))
(re-frame/reg-sub ::invite-form :<- [::state] (fn [s _] (:invite-form s)))
(re-frame/reg-sub ::current-page :<- [::state] (fn [s _] (get s :current-page 1)))
(re-frame/reg-sub ::total-count :<- [::state] (fn [s _] (get s :total-count 0)))

(defn- format-project-groups [{:keys [project_name groups]}]
  (format-translation
    (get-translation "users-view.groups-cell.entry" "Groups: %{groups} - %{project}")
    :groups (str/join ", " groups)
    :project project_name))

(defn- groups-text [row]
  (->> row
       :projects
       (map format-project-groups)
       (str/join " | ")))

(defn- groups-list [row]
  (vec (for [{:keys [project_name groups]} (:projects row)
             group groups]
         (utils/group-filter-label group project_name))))

;; Derived here rather than in the view so the labels are built once per server
;; response instead of on every grid re-render.
(re-frame/reg-sub
 ::rows
 :<- [::users]
 :<- [::pat-for-new-users-supported?]
 (fn [[users pat-supported?] _]
   (mapv #(assoc %
            :pat_state_label (if pat-supported?
                               (utils/pat-state-label (:pat_state %))
                               (get-translation "users-view.pat-state.disabled-for-professional"
                                                "Disabled for Professional accounts"))
            :groups_text (groups-text %)
            :groups_list (groups-list %))
         users)))

(re-frame/reg-sub
 ::group-filter-options
 :<- [::all-groups]
 (fn [all-groups _]
   (mapv #(utils/group-filter-label (:name %) (:project_name %)) all-groups)))

(re-frame/reg-sub
 ::projects
 :<- [::all-groups]
 (fn [all-groups _]
   (->> all-groups
        (group-by :project_id)
        (map (fn [[project-id groups]]
               {:id project-id
                :name (:project_name (first groups))
                :groups (vec (sort-by :name groups))}))
        (sort-by (comp str/lower-case :name))
        vec)))

(re-frame/reg-sub
 ::invite-seat-type
 :<- [::all-groups]
 :<- [::invite-form]
 (fn [[all-groups form] _]
   (let [selected-ids (set (mapcat :group-ids (:project-groups form)))
         seat-types (->> all-groups (filter #(selected-ids (:id %))) (map :seat_type) set)]
     (cond
       (empty? seat-types) nil
       (seat-types "Full Seat") "Full Seat"
       :else (first seat-types)))))

(re-frame/reg-sub
 ::invite-emails
 :<- [::invite-form]
 (fn [form _]
   (common-utils/split-comma-list (:email form))))

(re-frame/reg-sub
 ::selected-user-names
 :<- [::grid-subs/selection utils/selection-path]
 :<- [::state]
 (fn [[selection {:keys [user-names]}] _]
   (mapv #(get user-names % %) selection)))

(re-frame/reg-sub
 ::assigned-projects-count
 :<- [::invite-form]
 (fn [form _]
   (count (filter :project-id (:project-groups form)))))
